import { defineGlobals } from "vue-utils"
import { showModalMessage } from "./Modals"

export * from "./types"
export * from "./Modals"

defineGlobals({
	showModalMessage,
})
